// src/registeredTokens.ts

import { range } from '../helpers/utils.helper';
import { defineDesignTokens, defineBreakpoints } from '@contentful/experiences-sdk-react';
import { T_KeyValue } from '../types/app.type';
// import { BASEPLATE_APP_CONFIG } from '../config/app.config';
// import { getActData } from '../actions/page.action';


// import { defineDesignTokens } from '@contentful/experiences-sdk-react';

const colors: T_KeyValue = {
  body: '#000000',
  primary: '#FFE500',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  muted: '#c0c0c0',
  white: '#FFFFFF',
  transparent: 'transparent',
  black: '#000000',
};

const borders = (() => {
  let bdrs: T_KeyValue = {};
  for (const key in colors) {
    ['solid', 'dotted', 'dashed'].forEach((bType: string) => {
      range(1, 4).forEach((bWeight: number) => {
        bdrs[`border-${key}-${bType}-${bWeight}`] = {
          width: `${bWeight}px`,
          style: `${bType}`,
          color: `${colors[key]}`,
        };
      });
    });
  }
  return bdrs;
})();

const themes: any = {
  Esports: {
    "color": {
      'Dark-Blue': '#0F102A',
    }
  },
  Futures: {
    color: {
      "Coral-Blue": "#B6D9ED",
      "Grey": "#E0E0E0",
      "Sea-Mist": "#C0DDCC"
    }
  }
}

const commonDesignTokens: any = {
  spacing: { XS: '4px', S: '16px', M: '32px', L: '64px', XL: '128px' },
  sizing: { XS: '16px', S: '100px', M: '300px', L: '600px', XL: '1024px' },
  color: {
    Transparent: '#FFFFFF00',
    Yellow: '#FFDB00',
    White: '#FFFFFF',
    Dark: '#1A1A1A',
    Blue: '#B0D7EC',
    'Dark-grey': '#474747',
    'Light-Brown': '#F7F4EF',
    'Dark-Brown': '#EAE3DA',
  },
  Salmon: '#EF776E',

  border: {
    Azure: { width: '1px', style: 'solid', color: 'azure' },
    Hero: { width: '2px', style: 'dashed', color: '#ffaabb' },
    Card: { width: '1px', style: 'solid', color: '#ffccbb' },
    Carousel: { width: '2px', style: 'dotted', color: 'rgba(30, 25, 25, 0.75)' },
  },
  fontSize: { XS: '12px', SM: '14px', MD: '16px', LG: '24px', XL: '32px' },
  lineHeight: { XS: '1', SM: '1.25', MD: '1.5', LG: '200%' },
  letterSpacing: { None: '0', XS: '0.05em', SM: '0.1em', MD: '0.15em', LG: '0.2em' },
  textColor: {
    Dark: '#1a1a1a',
    Light: '#efefef',
    Slate: '#94a3b8',
    Blue: '#B0D7EC',
    'Dark-grey': '#474747',
  },
}

defineBreakpoints([
  {
    id: 'desktop',
    query: '*',
    displayName: 'All Sizes',
    previewSize: '100%',
  },
  {
    id: 'laptop',
    query: '<1280px',
    displayName: 'Laptop',
    previewSize: '1140px',
  },
  {
    id: 'tablet',
    query: '<1024px',
    displayName: 'Tablet',
    previewSize: '820px',
  },
  {
    id: 'mobile',
    query: '<576px',
    displayName: 'Mobile',
    previewSize: '390px',
  },
])

defineDesignTokens({
  ...commonDesignTokens,
  color: {
    ...commonDesignTokens?.color,
    ...themes?.Esports?.color,
    ...themes?.Futures?.color
  }
});

// console.log("Theme ---- ", theme, " | ThemeConfig ---- ", themeConfig);